import { ChangeEvent, useCallback, useMemo, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";


import useUiuxStore from "src/store/useUiuxStore";
import { defaultWMS1100_R01Filter, useWMS1100_R01Store } from "src/containers/mes/WMS/WMS1100_R01/Store_WMS1100_R01";

import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchInputForm } from "src/components/common/form/search/SearchInputForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { LabelPrintData } from "src/apis/labelApi";
import LabelPrintButton from "src/components/common/LabelPrintButton";
import { showError, showSuccess, showWarning } from "src/utils/toast/toastUtil";
import { WMS1100_R01_buildLabelDataListFromSelectedLots } from "./labelDataBuilder_WMS1100_R01";

interface Props {
  onEnterKeyDown: () => void;
}

export const SearchSection_WMS1100_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;
	const { 
		WMS1100_R01Filter, 
		setWMS1100_R01Filter, 
		selectedWMS1100_R01LotList, 
		WMS1100_R01LotList, 
		WMS1100_R01DetailList,
		selectedWMS1100_R01,
	} = useWMS1100_R01Store();

	// 선택된 여러 LOT → 라벨 출력용 데이터 배열 (여러 행 선택 시 일괄 출력)
	const selectedLabelDataList = useMemo((): LabelPrintData[] => {
		if (!selectedWMS1100_R01 || selectedWMS1100_R01LotList.length === 0 || WMS1100_R01LotList.length === 0) return [];
		return WMS1100_R01_buildLabelDataListFromSelectedLots(
			selectedWMS1100_R01LotList,
			WMS1100_R01LotList,
			{ WMS1100_R01LotMap: new Map(), WMS1100_R01DetailList, selectedWMS1100_R01 }
		);
	}, [selectedWMS1100_R01, selectedWMS1100_R01LotList, WMS1100_R01LotList, WMS1100_R01DetailList]);

    const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });
	
	const custInfoHandleFoucsId = 'infoCustInput_search';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: WMS1100_R01Filter.customCd || '',
				customNm: WMS1100_R01Filter.customNm || '',
			}),
		},		
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: WMS1100_R01Filter,
		setEditData: setWMS1100_R01Filter,
		defaultData: defaultWMS1100_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL2020_R01_search'
	});

    // UI 렌더링
    return (
		<>
		<SearchSectionForm>
			<SearchDateRangeForm
				label="입고 조회 기간"
				visible={pickerVisible}						setVisible={setPickerVisible}
				dateRange={WMS1100_R01Filter.dateRange}		setDateRange={(dateRange) => setWMS1100_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[80px] min	-w-[80px]",
				}}
			/>

			{/* 거래처 입력 및 검색 영역 */}
			<SearchCodeModalForm
				label="거래처"
				value={WMS1100_R01Filter.customCd}
				valueLabel={WMS1100_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
			<LabelPrintButton
				labelDataList={selectedLabelDataList}
				disabled={selectedLabelDataList.length === 0}
				buttonText="라벨 출력"
			/>
		</SearchSectionForm>
		{/* searchedCustomer : {JSON.stringify(searchedCustomer)} */}
		</>
	)
}

export default SearchSection_WMS1100_R01;